import { createContext, useContext } from 'react';
import { GithubInstallationContextValue } from './types';

export const GithubInstallationContext = createContext<
  GithubInstallationContextValue | undefined
>(undefined);

/**
 * Hook to access the GitHub installation context.
 *
 * Provides access to the organization URL state for the GitHub app installation flow.
 *
 * @returns The GitHub installation context value containing:
 * - `organizationUrl` - The current GitHub organization URL
 * - `setOrganizationUrl` - Function to update the organization URL
 *
 * @throws Error if used outside GithubInstallationContext.Provider
 *
 * @example
 * ```tsx
 * const { organizationUrl, setOrganizationUrl } = useGithubInstallation();
 * ```
 */
export const useGithubInstallation = () => {
  const context = useContext(GithubInstallationContext);

  if (!context) {
    throw new Error(
      'useGithubInstallation must be used within GithubInstallationContext.Provider',
    );
  }

  return context;
};
